<button mat-icon-button [matMenuTriggerFor]="menu"
        matTooltip="Notification"
        i18n-matTooltip="@@UserNotificationTooltip"
        aria-label="View notifications"
        i18n-aria-label="@@ViewNotifications">
  @if (countUnReadNotifications$() > 0) {
    <mat-icon matBadge="{{countUnReadNotifications$()}}">notifications_active</mat-icon>
  } @else {
    <mat-icon>notifications</mat-icon>
  }
</button>

<mat-menu #menu="matMenu" class="user-menu">
  @if (notifications$().length > 0) {
    <div>
      <mat-list class="notification-list">
        @for (notification of notifications$(); track notification) {
          <mat-list-item (click)="markAsRead(notification?.notificationId);$event.stopPropagation()" class="notification-item">
            <div class="notification-wrapper">
              <div class="notification-status">
                @if (!notification?.read) {
                  <mat-icon class="unread-dot">circle</mat-icon>
                }
              </div>
              <div class="notification-content">
                {{ notification?.content }}
              </div>
            </div>
          </mat-list-item>
        }
      </mat-list>
      <div class="notification-footer">
        <button mat-button (click)="markAllAsRead();$event.stopPropagation()" i18n="@@MarkAllAsRead">Mark all as read</button>
        <button mat-button (click)="clearNotifications();$event.stopPropagation()" i18n="@@ClearNotifications">Clear notifications</button>
      </div>
    </div>
  } @else {
    <mat-list>
      <mat-list-item i18n="@@NoNotificationsAvailable">No notifications available.</mat-list-item>
    </mat-list>
  }
</mat-menu>
